import { CSSProperties } from 'react';

export const headerStyles: CSSProperties = {
  position: 'sticky',
  top: 0,
  zIndex: 1,
  width: '100%',
  backgroundColor: 'rgb(255 255 255)',
  borderBottom: '2px solid #003666',
  borderImageSlice: '1',
};

export const style: CSSProperties = {
  backgroundColor: '#003666',
  overflow: 'auto',
  position: 'fixed',
  left: 0,
  top: 0,
  bottom: 0,
  zIndex: 2,
};
